<template>
  <div>
    <div
      class="ConfirmDelete big-container md:h-screen flex justify-center py-8"
      v-if="!approvDelete"
    >
      <div
        class="flex justify-center items-center w-11/12 lg:w-2/3 bg-white overflow-y-auto"
      >
        <div class="max-h-screen py-20">
          <icon
            :data="icons.ConfirmDelete"
            height="187"
            width="242"
            original
            class=""
          />
          <div class="w-11/12 lg:w-2/5 font-c7 text-c24 mx-auto mt-5">
            Confirmer votre demande de suppression.
          </div>
          <div class="w-11/12 lg:w-2/5 mx-auto mt-3">
            Pour des raisons de sécurité, cette action nécessite une
            confirmation de votre part. Une fois votre demande confirmée, les
            données suivantes seront définitivement supprimées de nos systèmes :
          </div>
          <div class="card2 w-11/12 xl:w-2/3 mt-5 mx-auto rounded-14 p-8">
            <div class="text-[#FD3A30] txt1 lg:w-2/3 mx-auto">
              Votre compte e-tchité et vos données seront supprimées !!
            </div>
            <div class="flex justify-center">
              <div class="mt-3">
                <div class="flex items-center gap-2 mb-2">
                  <span class="font-c8">.</span>
                  <div>
                    Vos informations personnelles (nom, email, téléphone, etc.)
                  </div>
                </div>
                <div class="flex items-center gap-2 mb-2">
                  <span class="font-c8">.</span>
                  <div>Votre profil utilisateur</div>
                </div>
                <div class="flex items-center gap-2 mb-2">
                  <span class="font-c8">.</span>
                  <div>Votre historique d’activité</div>
                </div>
                <div class="flex items-center gap-2 mb-2">
                  <span class="font-c8">.</span>
                  <div>
                    Vos fichiers ou contenus enregistrés (si applicable)
                  </div>
                </div>
                <div class="flex items-center gap-2">
                  <span class="font-c8">.</span>
                  <div>Vos préférences et paramètres</div>
                </div>
              </div>
            </div>
            <!-- Operation card -->
            <div class="bg-white lg:w-3/4 mt-5 rounded-14 p-5 mx-auto">
              <div class="flex items-center gap-2">
                <icon
                  :data="icons.Notif"
                  height="20"
                  width="20"
                  original
                  class=""
                />
                <div class="font-c7 text-c16 text-left">
                  Cette opération est irréversible.
                </div>
              </div>
              <div class="text-left px-8 mt-1">
                Aucune récupération de compte ou de données ne sera possible
                après validation.
              </div>
            </div>

            <!-- Treatment card -->
            <div class="bg-white lg:w-3/4 mt-4 rounded-14 p-5 mx-auto">
              <div class="flex items-center gap-2">
                <icon
                  :data="icons.Horloge"
                  height="20"
                  width="20"
                  original
                  class=""
                />
                <div class="font-c7 text-c16">Délai de traitement :</div>
              </div>
              <div class="text-left px-8 mt-1">
                Après confirmation, la suppression complète de vos données
                interviendra conformément à notre politique de confidentialité.
              </div>
            </div>
          </div>
          <div class="mt-5 w-11/12 lg:w-3/6 mx-auto txt2">
            Si vous n’êtes pas à l’origine de cette demande, merci de nous
            contacter dès maintenant le support client de e-tchité
            <a
              href="mailto:e-tchite@ccib.bj"
              class="text-blue-500 hover:underline cursor-pointer"
            >
              e-tchite@ccib.bj
            </a>
          </div>
          <!-- Button -->
          <div
            class="flex flex-col lg:flex-row justify-center mt-8 gap-3 pb-16 px-16"
          >
            <buton
              label="Confirmer ma demande"
              class="lg:w-1/2"
              size="18px"
              rounded="6px"
              weight="500"
              background="#312879"
              @click="ConfirmDelete()"
            />
            <!-- <buton
              label="Confirmer ma demande"
              class="lg:w-1/4"
              size="18px"
              rounded="6px"
              weight="500"
              background="#E8E7F0"
              color="#312879"
              @click="ConfirmDelete()"
            /> -->
          </div>
        </div>
      </div>
    </div>
    <!-- Approv Delete -->
    <div v-if="approvDelete">
      <approvDeleteVue @closeDelete="closeDelete" />
    </div>
  </div>
</template>

<script>
import ConfirmDelete from "../../assets/icons/ic_confirmDelete.svg";
import Notif from "../../assets/icons/ic_notif.svg";
import Horloge from "../../assets/icons/ic_horloge.svg";
import buton from "../../component/helper/add/button";
import approvDeleteVue from "../../component/cdevs/confirmDelete/approvDelete.vue";
import http from "@/plugins/https";
import apiroutes from "../../router/api-routes";
import store from "@/store";

export default {
  name: "Index",

  components: { buton, approvDeleteVue },

  data() {
    return {
      icons: {
        ConfirmDelete,
        Notif,
        Horloge,
      },
      token: this.$route.query.token || null,
      approvDelete: false,
      charge: false,
    };
  },

  methods: {
    closeDelete() {
      this.approvDelete = false;
    },
    ConfirmDelete() {
      // Utilise le token récupéré de l'URL
      console.log("token", this.token);
      this.charge = true;
      http
        .post(apiroutes.baseURL + apiroutes.confirm_delete, {
          data: { token: this.token },
        })
        .then(() => {
          this.charge = false;
          this.approvDelete = true;
        })
        .catch((error) => {
          this.charge = false;
          this.$toast.error("Erreur lors de la confirmation de désactivation");
          console.error("Erreur lors de la désactivation :", error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/sass/variables";
.big-container {
  width: 100%;
  background-color: #e8e7f0;
}
.card2 {
  background-color: #fd3a300f;
}

.txt1 {
  color: #fd3a30;
  font-size: 20px;
  font-weight: 700;
}
.txt2 {
  color: #7b829b;
  font-size: 14px;
  font-weight: 500;
}

.txt3 {
  color: #4679fa;
  font-size: 14px;
  font-weight: 500;
}
</style>
